export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-19.3aeee482.jpg";